module.exports = __webpack_public_path__ + "static/media/bgt.3d53dc7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bgt.png
// module id = 149
// module chunks = 0